var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusiness2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2788.75 2813.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-53{fill:#fff;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#bdd0fb;}.cls-4{fill:#7d97f4;}.cls-5{fill:#91b3fa;}.cls-6{fill:url(#linear-gradient-2);}.cls-7{fill:#f0f0f0;}.cls-8{fill:#18174a;}.cls-9{fill:#2b69b3;}.cls-10{fill:url(#linear-gradient-3);}.cls-11{fill-rule:evenodd;fill:url(#linear-gradient-4);}.cls-12{fill:url(#linear-gradient-5);}.cls-13{fill:url(#linear-gradient-6);}.cls-14{fill:url(#linear-gradient-7);}.cls-15{fill:url(#linear-gradient-8);}.cls-16{fill:url(#linear-gradient-9);}.cls-17{fill:url(#linear-gradient-10);}.cls-18{fill:url(#linear-gradient-11);}.cls-19{fill:url(#linear-gradient-12);}.cls-20{fill:url(#linear-gradient-13);}.cls-21{fill:url(#linear-gradient-14);}.cls-22{fill:url(#linear-gradient-15);}.cls-23{fill:url(#linear-gradient-16);}.cls-24{fill:url(#linear-gradient-17);}.cls-25{fill:url(#linear-gradient-18);}.cls-26{fill:url(#linear-gradient-19);}.cls-27{fill:url(#linear-gradient-20);}.cls-28{fill:url(#linear-gradient-21);}.cls-29{fill:url(#linear-gradient-22);}.cls-30{fill:url(#linear-gradient-23);}.cls-31{fill:url(#linear-gradient-24);}.cls-32{fill:url(#linear-gradient-25);}.cls-33{fill:url(#linear-gradient-26);}.cls-34{fill:url(#linear-gradient-27);}.cls-35{fill:url(#linear-gradient-28);}.cls-36{fill:url(#linear-gradient-29);}.cls-37{fill:url(#linear-gradient-30);}.cls-38{fill:url(#linear-gradient-31);}.cls-39{fill:url(#linear-gradient-32);}.cls-40{fill:url(#linear-gradient-33);}.cls-41{fill:url(#linear-gradient-34);}.cls-42{fill:url(#linear-gradient-35);}.cls-43{fill:url(#linear-gradient-36);}.cls-44{fill:url(#linear-gradient-37);}.cls-45{fill:url(#linear-gradient-38);}.cls-46{fill:url(#linear-gradient-39);}.cls-47{fill:url(#linear-gradient-40);}.cls-48{fill:url(#linear-gradient-41);}.cls-49{fill:url(#linear-gradient-42);}.cls-50{fill:url(#linear-gradient-43);}.cls-51{fill:url(#linear-gradient-44);}.cls-52{fill:url(#linear-gradient-45);}.cls-53{opacity:0.2;}.cls-54{fill:url(#linear-gradient-46);}.cls-55{fill:url(#linear-gradient-47);}.cls-56{fill:url(#linear-gradient-48);}.cls-57{fill:url(#linear-gradient-49);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2965.76,
    y1: 2844.28,
    x2: 917.66,
    y2: 1052.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2596.91,
    y1: 1602.5,
    x2: 2738.05,
    y2: 1602.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1484.74,
    y1: 628.38,
    x2: 1813.9,
    y2: 628.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1597.76,
    y1: 632.6,
    x2: 1730.09,
    y2: 632.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1460.46,
    y1: 1265.4,
    x2: 1906.94,
    y2: 1265.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1461.88,
    y1: 1213.64,
    x2: 1805.22,
    y2: 1213.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1672.8,
    y1: 1295.48,
    x2: 1703.16,
    y2: 1295.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1558.13,
    y1: 1295.48,
    x2: 1585.11,
    y2: 1295.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1478.5,
    y1: 1301.33,
    x2: 1777.53,
    y2: 1301.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1676.87,
    y1: 1456.58,
    x2: 1732.5,
    y2: 1456.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1507.3,
    y1: 1456.58,
    x2: 1562.94,
    y2: 1456.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 779.05,
    y1: 628.48,
    x2: 1156.79,
    y2: 628.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 786.35,
    y1: 561.21,
    x2: 1143.49,
    y2: 561.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 788.51,
    y1: 665.13,
    x2: 915.97,
    y2: 665.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1014.96,
    y1: 665.13,
    x2: 1142.42,
    y2: 665.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 795.91,
    y1: 1299.64,
    x2: 1190.51,
    y2: 1299.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1045.49,
    y1: 1142.81,
    x2: 1129.81,
    y2: 1142.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1035.37,
    y1: 1232.19,
    x2: 1112.94,
    y2: 1232.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 863.37,
    y1: 1304.7,
    x2: 1038.74,
    y2: 1304.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 773.8,
    y1: 1984.84,
    x2: 1137.2,
    y2: 1984.84,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 911.98,
    y1: 1986.08,
    x2: 998.87,
    y2: 1986.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 907.94,
    y1: 1986.08,
    x2: 1002.91,
    y2: 1986.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 833.06,
    y1: 1985.66,
    x2: 1068.84,
    y2: 1985.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 829.02,
    y1: 1985.66,
    x2: 1072.88,
    y2: 1985.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 813.4,
    y1: 1924.55,
    x2: 1096.69,
    y2: 1924.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 809.36,
    y1: 1924.55,
    x2: 1100.73,
    y2: 1924.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 854.45,
    y1: 1865.07,
    x2: 1055.65,
    y2: 1865.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 850.41,
    y1: 1865.07,
    x2: 1059.73,
    y2: 1865.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 801.11,
    y1: 1984.04,
    x2: 1108.99,
    y2: 1984.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 797.07,
    y1: 1984.04,
    x2: 1113.05,
    y2: 1984.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 813.4,
    y1: 2043.53,
    x2: 1096.69,
    y2: 2043.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 809.36,
    y1: 2043.52,
    x2: 1100.73,
    y2: 2043.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 859.12,
    y1: 2103.01,
    x2: 1061.15,
    y2: 2103.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 855.08,
    y1: 2103.01,
    x2: 1065.19,
    y2: 2103.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1453.58,
    y1: 2066.92,
    x2: 1544.64,
    y2: 2066.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 1551.39,
    y1: 2039.94,
    x2: 1645.82,
    y2: 2039.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 1652.57,
    y1: 2014.64,
    x2: 1753.75,
    y2: 2014.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1763.86,
    y1: 1989.35,
    x2: 1865.04,
    y2: 1989.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1194.85,
    y1: 2684.49,
    x2: 1256.58,
    y2: 2684.49,
    gradientTransform: "translate(-1140.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -124,
    y1: 4031.38,
    x2: 368.41,
    y2: 3370.34,
    gradientTransform: "translate(-1140.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 1477.65,
    y1: 1787.16,
    x2: 1257.92,
    y2: 1981.74,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -268.92,
    y1: 3923.43,
    x2: 223.49,
    y2: 3262.39,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 41.45,
    y1: 4154.62,
    x2: 533.85,
    y2: 3493.58,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 1889.57,
    y1: 1805.57,
    x2: 2062.62,
    y2: 1805.57,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 1721.36,
    y1: 1343.12,
    x2: 1719.47,
    y2: 1666.27,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 1483.39,
    y1: 3084.73,
    x2: 1324.31,
    y2: 3295.17,
    gradientTransform: "translate(-1223.12 -1551.15) rotate(-8.21)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 1250.41,
    y1: 3251.38,
    x2: 1378,
    y2: 3120.47,
    gradientTransform: "translate(-1223.12 -1551.15) rotate(-8.21)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 1564.42,
    y1: 1885.15,
    x2: 1344.69,
    y2: 2079.73,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 2044.23,
    y1: 1785.24,
    x2: 2106.2,
    y2: 1785.24,
    xlinkHref: "#linear-gradient-39"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -460.63,
    y: -430.07,
    width: 3710,
    height: 3710
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2617.69,1913.57C2353,2536.82,1647.9,2886,1036.45,2791.79c-99.5-15.32-372.27-61-613.77-276.34C-42.23,2100.84-141.65,1279.88,233.37,701.32c273-421.08,762.25-659.78,1227.18-647.84C1560.69,56.05,1944.49,71.9,2281.79,350,2331.33,390.88,2440.6,488,2539.08,642,2770.32,1003.57,2790.2,1507.39,2617.69,1913.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1984.2,2713.49c135.76,27.15,309.13-120.86,365-282.56,57.48-166.4-47.9-236.11-47.09-467,.92-262.3,137.37-301.83,227.62-655.39,20.36-79.77,138.2-541.39-7.85-627.92-135-80-514.34,149.6-580.82,443.47-47.41,209.54,99.13,297.52,43.16,541.58-49.1,214.14-178.17,217.24-227.62,423.85C1696.38,2341,1806,2677.85,1984.2,2713.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1994.06,2777c-36.59-282.61,34.8-718.61,101.14-1034.6,71.82-342.12,153.33-621.17,154.15-623.95l11.29,3.31c-.81,2.78-82.21,281.46-153.94,623.14-66.14,315.08-137.34,749.63-101,1030.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2019.91,2702.18c-178.08-92.79-239-411.42-137.81-515,68.4-70,166.48,3.62,261.11-68.91,120.82-92.6,31.94-267,126.93-493.2,80.83-192.5,274.73-374.64,388-337.27,118.6,39.12,181.07,329.39,79.78,504.09-65.87,113.6-166.7,119.18-188.58,224.84-25.38,122.6,97.25,178.52,97.92,297.38C2648.5,2527.65,2255.5,2824.93,2019.91,2702.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2116,2783.77a7.17,7.17,0,0,1-3.17-.73,7.25,7.25,0,0,1-3.35-9.69c236.08-486.48,305.31-1050.84,306-1056.48a7.26,7.26,0,1,1,14.41,1.71c-.68,5.67-70.2,572.45-307.34,1061.11A7.26,7.26,0,0,1,2116,2783.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2600.37,1863a3.46,3.46,0,0,1-2.73-5.6c74.52-95.65,157.11-239.36,127.38-380.78-17.71-84.22-67.55-128.15-68.05-128.58a3.47,3.47,0,0,1,4.54-5.24c2.12,1.83,52.11,45.91,70.29,132.4,16.71,79.49,7.95,211.07-128.69,386.46A3.47,3.47,0,0,1,2600.37,1863Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2003.85,2659.69a3.48,3.48,0,0,1-2.86-1.5c-114.52-167.14-153.58-296.29-116.07-383.85,33.34-77.85,117.53-92.34,118.37-92.48a3.47,3.47,0,0,1,1.12,6.85c-.81.13-81.37,14.1-113.16,88.44-36.44,85.24,2.4,212.12,115.46,377.12a3.46,3.46,0,0,1-2.86,5.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2200.85,150c-.42,445.17-3.83,1980.66-30.47,2524.23-2.82,57.59-43.33,103-92.62,103.76-243.81,3.93-1137.36,7.79-1535.38-20.58-82.9-5.91-147.16-86-146.73-183.21C397.71,2107,408.52,793,465.26,192.15c6.81-72,56.45-128.33,118.15-134.17,266-25.17,1164.54-81.21,1508.2-47.45C2153.58,16.61,2200.92,77.18,2200.85,150Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2089.13,284.08c5.16,359.44,20.07,1555.14-2.84,1996.66-3.35,64.54-48,115.79-103.23,118.34-227.37,10.52-1002.69,27.64-1335-10.93-59.83-6.94-105.63-64.71-107.31-135.05C532,1886.32,508.18,772.73,530.43,336.15c3.56-69.64,51-125.54,110.47-130.46,246.17-20.36,1070.58-63.52,1353.15-39.19C2047.09,171.07,2088.24,221.85,2089.13,284.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1999.94,388.72c4.58,318.29,17.78,1377.14-2.51,1768.12-3,57.15-42.52,102.54-91.42,104.8-201.34,9.31-887.92,24.47-1182.18-9.68-53-6.15-93.54-57.31-95-119.6C621,1807.57,600,821.44,619.65,434.83c3.15-61.68,45.13-111.17,97.82-115.53,218-18,948.05-56.25,1198.28-34.71C1962.72,288.63,1999.15,333.61,1999.94,388.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1600.12,77.43h0c-.3,13.65-9.65,24.71-21.32,25.17-57.61,2.25-219.92,8.64-292.46,12-14.31.65-25.18-14.61-22.11-31l.52-2.79c2.1-11.17,10.24-19.44,20-20.27,49.08-4.16,197.15-15.44,295-9.19C1591.43,52.06,1600.42,63.67,1600.12,77.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1252.5,865.69c0,26.94-24.21,48.79-54.08,48.79h-462c-29.86,0-54.08-21.85-54.08-48.79V386.31c0-26.94,24.22-48.79,54.08-48.79h462c29.87,0,54.08,21.85,54.08,48.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1937.52,865.69c0,26.94-24.21,48.79-54.08,48.79h-462c-29.87,0-54.08-21.85-54.08-48.79V386.31c0-26.94,24.21-48.79,54.08-48.79h462c29.87,0,54.08,21.85,54.08,48.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1252.5,1546c0,27-24.21,48.79-54.08,48.79h-462c-29.86,0-54.08-21.84-54.08-48.79V1066.58c0-26.95,24.22-48.8,54.08-48.8h462c29.87,0,54.08,21.85,54.08,48.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1937.52,1546c0,27-24.21,48.79-54.08,48.79h-462c-29.87,0-54.08-21.84-54.08-48.79V1066.58c0-26.95,24.21-48.8,54.08-48.8h462c29.87,0,54.08,21.85,54.08,48.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1252.5,2226.22c0,26.94-24.21,48.79-54.08,48.79h-462c-29.86,0-54.08-21.85-54.08-48.79V1746.84c0-26.95,24.22-48.79,54.08-48.79h462c29.87,0,54.08,21.84,54.08,48.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1937.52,2226.22c0,26.94-24.21,48.79-54.08,48.79h-462c-29.87,0-54.08-21.85-54.08-48.79V1746.84c0-26.95,24.21-48.79,54.08-48.79h462c29.87,0,54.08,21.84,54.08,48.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1649.32,793c-90.75,0-164.58-73.83-164.58-164.58s73.83-164.58,164.58-164.58,164.58,73.83,164.58,164.58S1740.07,793,1649.32,793Zm0-301.58c-75.55,0-137,61.46-137,137s61.45,137,137,137,137-61.46,137-137S1724.86,491.38,1649.32,491.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1597.76,691.76V573.44a16.31,16.31,0,0,1,24.64-14l99.7,59.16a16.32,16.32,0,0,1,0,28.06l-99.7,59.16A16.32,16.32,0,0,1,1597.76,691.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1507.54,1402.5h235.35c6.13,0,11.53-3.55,13.27-9.43L1823.83,1165l71.07-9.21a13.8,13.8,0,1,0-3.6-27.36l-80,10.51a13.7,13.7,0,0,0-11.47,9.67l-67.29,226.91H1519l-31.1-164.23a13.85,13.85,0,0,0-27.2,5.24l33.22,175.17C1495.17,1398.24,1500.88,1402.5,1507.54,1402.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1475.73,1227.13h315.65a13.49,13.49,0,1,0,0-27H1475.73a13.49,13.49,0,1,0,0,27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1688,1389.62c7.65,0,15.18-6.2,15.18-13.84v-160.6c0-7.64-7.53-13.84-15.18-13.84s-15.18,6.2-15.18,13.84v160.6C1672.8,1383.42,1680.33,1389.62,1688,1389.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1571.62,1389.62a13.54,13.54,0,0,0,13.49-13.84v-160.6a13.49,13.49,0,1,0-27,0v160.6A13.55,13.55,0,0,0,1571.62,1389.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1492.34,1314.82h271.35a13.5,13.5,0,1,0,0-27H1492.34a13.5,13.5,0,1,0,0,27Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 1704.69,
    cy: 1456.58,
    r: 27.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 1535.12,
    cy: 1456.58,
    r: 27.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1156.79,738.23a40.33,40.33,0,0,1-40.34,40.33H819.39a40.33,40.33,0,0,1-40.34-40.33V518.73a40.34,40.34,0,0,1,40.34-40.33h297.06a40.34,40.34,0,0,1,40.34,40.33Zm-23.61-215.72a13.76,13.76,0,0,0-13.76-13.76H819.79A13.76,13.76,0,0,0,806,522.51V741.2A13.76,13.76,0,0,0,819.79,755h299.63a13.76,13.76,0,0,0,13.76-13.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M966,633.47a13.23,13.23,0,0,1-7.69-2.45L792,513.08a13.29,13.29,0,0,1,15.38-21.68L966,603.89l156.55-111.2a13.29,13.29,0,0,1,15.39,21.67L973.66,631A13.33,13.33,0,0,1,966,633.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M801.73,768.25,797.81,742l1.84,13.16-11.14-7.24C791.59,743,851.57,638,891.14,568.72a13.29,13.29,0,1,1,23.08,13.17s-25.65,45-51.36,89.9c-12.86,22.48-25.73,45-35.41,61.83C808.15,767.23,808.15,767.23,801.73,768.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1129.19,768.25c-6.41-1-6.41-1-25.71-34.63-9.68-16.87-22.55-39.35-35.41-61.83-25.71-44.95-51.36-89.9-51.36-89.9a13.29,13.29,0,1,1,23.08-13.17C1079.36,638,1139.34,743,1142.42,747.89l-11.14,7.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1190.51,1394a55.77,55.77,0,0,1-55.77,55.77H851.68A55.77,55.77,0,0,1,795.91,1394V1205.33a55.77,55.77,0,0,1,55.77-55.77h283.06a55.77,55.77,0,0,1,55.77,55.77Zm-23.61-186.39a31,31,0,0,0-31-31h-282a31,31,0,0,0-31,31v184.16a31,31,0,0,0,31,31h282a31,31,0,0,0,31-31Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 1045.49,
    y: 1122.58,
    width: 84.32,
    height: 40.47,
    rx: 19.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 1035.37,
    y: 1217.01,
    width: 77.57,
    height: 30.35,
    rx: 14.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1038.74,1308.38a84,84,0,0,1-84,84h-7.37a84,84,0,0,1-84-84V1301a84,84,0,0,1,84-84h7.37a84,84,0,0,1,84,84Zm-27-11.88a59.24,59.24,0,0,0-59.25-59.25h-9.66a59.25,59.25,0,0,0-59.25,59.25v9.65a59.26,59.26,0,0,0,59.25,59.26h9.66a59.25,59.25,0,0,0,59.25-59.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M956.83,2154.7c-2.91,0-5.82-.06-8.75-.19C848,2150.1,769.86,2070.4,774,1976.84c2-45.49,22.85-87.37,58.74-117.93,35.65-30.35,81.93-45.86,130.22-43.75,100.11,4.41,178.22,84.11,174.13,177.66h0c-2,45.49-22.86,87.37-58.75,117.93C1044.81,2139.26,1002,2154.7,956.83,2154.7Zm-2.65-315.79c-39.46,0-76.82,13.43-105.95,38.23-30.78,26.2-48.66,62-50.35,100.74-3.52,80.37,64.34,148.88,151.25,152.71,42.24,1.82,82.63-11.65,113.64-38.07,30.78-26.19,48.66-62,50.35-100.74,3.52-80.37-64.34-148.87-151.25-152.7C959.3,1839,956.73,1838.91,954.18,1838.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M998.87,1985.6c0,27.84-2,55.74-6.84,83.19-1.23,6.86-2.67,13.68-4.38,20.44a197,197,0,0,1-6.11,20,95,95,0,0,1-9.13,18.85,38,38,0,0,1-6.85,8,20,20,0,0,1-4.49,2.9,13.45,13.45,0,0,1-5.23,1.23,13.11,13.11,0,0,1-5.29-1,18.23,18.23,0,0,1-4.59-2.75,35.75,35.75,0,0,1-7-7.89,92.16,92.16,0,0,1-9.26-18.79,193.8,193.8,0,0,1-6.18-20c-1.73-6.75-3.17-13.57-4.42-20.43-2.49-13.71-4.19-27.55-5.34-41.44s-1.71-27.81-1.77-41.74c0-7,.15-13.93.4-20.89s.64-13.91,1.15-20.85c1-13.89,2.56-27.75,4.84-41.49,1.14-6.87,2.47-13.71,4.08-20.49a195.14,195.14,0,0,1,5.79-20.09c1.16-3.28,2.44-6.53,3.89-9.71a70.53,70.53,0,0,1,5-9.21,34.41,34.41,0,0,1,6.84-8,17.66,17.66,0,0,1,4.53-2.72,12.68,12.68,0,0,1,5.2-.93,13.86,13.86,0,0,1,5.15,1.21,20.72,20.72,0,0,1,4.47,2.8,38.76,38.76,0,0,1,7,7.81,94.39,94.39,0,0,1,9.59,18.57,192,192,0,0,1,6.57,19.84c1.85,6.71,3.42,13.51,4.78,20.34C996.6,1929.84,998.79,1957.75,998.87,1985.6Zm-2.06,0q0-20.82-1.65-41.58a399.64,399.64,0,0,0-5.4-41.24c-1.28-6.82-2.76-13.6-4.53-20.3a189.71,189.71,0,0,0-6.32-19.79,93,93,0,0,0-9.29-18.48,37.54,37.54,0,0,0-6.76-7.73,19.81,19.81,0,0,0-4.29-2.75,12.8,12.8,0,0,0-4.9-1.2,12,12,0,0,0-4.93.94,16.35,16.35,0,0,0-4.32,2.66,33.18,33.18,0,0,0-6.6,7.84,69.37,69.37,0,0,0-4.82,9.15c-1.4,3.16-2.63,6.4-3.75,9.67a195.31,195.31,0,0,0-5.54,20c-1.52,6.76-2.78,13.58-3.84,20.44-2.12,13.71-3.5,27.53-4.37,41.38s-1.18,27.73-1.16,41.61.43,27.75,1.45,41.58,2.62,27.63,5,41.3c1.19,6.83,2.58,13.62,4.24,20.35a192.49,192.49,0,0,0,6,19.87,90.59,90.59,0,0,0,9,18.59,34.67,34.67,0,0,0,6.69,7.68,17.17,17.17,0,0,0,4.29,2.61,11.72,11.72,0,0,0,4.84.92,12.25,12.25,0,0,0,4.8-1.18,18.31,18.31,0,0,0,4.19-2.76,36.34,36.34,0,0,0,6.56-7.82,92.91,92.91,0,0,0,8.84-18.65,197.79,197.79,0,0,0,5.92-19.9c1.64-6.73,3-13.52,4.19-20.36,2.36-13.66,3.92-27.46,5-41.29S996.82,1999.47,996.81,1985.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M955.44,2144.31A17.23,17.23,0,0,1,949,2143a22,22,0,0,1-5.59-3.33,38.62,38.62,0,0,1-7.82-8.78,94.73,94.73,0,0,1-9.7-19.64,194.11,194.11,0,0,1-6.32-20.41c-1.67-6.51-3.14-13.29-4.49-20.71-2.39-13.15-4.15-26.83-5.38-41.83-1.12-13.64-1.73-27.79-1.8-42.06,0-7.46.19-14.82.41-21,.26-7.08.65-14.14,1.16-21,1.11-15.09,2.71-28.78,4.88-41.86,1.24-7.45,2.59-14.24,4.13-20.77a199.79,199.79,0,0,1,5.92-20.49c1.32-3.72,2.63-7,4-10a74.94,74.94,0,0,1,5.26-9.74,37.84,37.84,0,0,1,7.68-8.87,21.14,21.14,0,0,1,5.6-3.35,16.8,16.8,0,0,1,6.84-1.21,17.46,17.46,0,0,1,6.61,1.55,23.71,23.71,0,0,1,5.38,3.35,41.62,41.62,0,0,1,7.76,8.64,96.72,96.72,0,0,1,10,19.38,192.5,192.5,0,0,1,6.73,20.27c1.8,6.54,3.38,13.28,4.84,20.64,5.1,26,7.62,53.42,7.71,83.88v0c0,30.66-2.3,58.1-6.9,83.9-1.34,7.42-2.79,14.19-4.44,20.73a199.63,199.63,0,0,1-6.25,20.42,98.06,98.06,0,0,1-9.53,19.66,40.93,40.93,0,0,1-7.62,8.89,23.11,23.11,0,0,1-5.43,3.5,17.19,17.19,0,0,1-6.83,1.6Zm-2.1-307.72a7.91,7.91,0,0,0-3.06.63,12.78,12.78,0,0,0-3.29,2,29.19,29.19,0,0,0-5.77,6.9,66.48,66.48,0,0,0-4.53,8.61c-1.25,2.81-2.43,5.87-3.62,9.34a190.14,190.14,0,0,0-5.42,19.6c-1.43,6.34-2.66,12.94-3.79,20.18-2,12.83-3.4,26.24-4.32,41-.81,12.62-1.19,26.15-1.16,41.35,0,14,.45,27.91,1.44,41.29,1.1,14.68,2.72,28.06,4.95,40.9,1.25,7.18,2.62,13.75,4.18,20.07A191.14,191.14,0,0,0,934.8,2108a86.36,86.36,0,0,0,8.56,17.75,30.15,30.15,0,0,0,5.87,6.77,13.19,13.19,0,0,0,3.25,2,8.79,8.79,0,0,0,3.2.63,8.31,8.31,0,0,0,3.24-.81,14.15,14.15,0,0,0,3.25-2.17,31.76,31.76,0,0,0,5.81-6.95,89.05,89.05,0,0,0,8.43-17.82,191.55,191.55,0,0,0,5.78-19.48c1.54-6.29,2.89-12.86,4.14-20.08,2.19-12.72,3.8-26.11,4.91-40.91,1-13.35,1.54-27.23,1.53-41.28h0c0-14-.52-27.87-1.63-41.24a397.7,397.7,0,0,0-5.35-40.83c-1.33-7.11-2.79-13.65-4.47-20a185.68,185.68,0,0,0-6.18-19.36,88.56,88.56,0,0,0-8.86-17.67,32.73,32.73,0,0,0-6-6.88,15.12,15.12,0,0,0-3.38-2.19,8.76,8.76,0,0,0-3.32-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1068.84,1985.6a204,204,0,0,1-7.18,53.16,171.47,171.47,0,0,1-22.15,48.74,139.83,139.83,0,0,1-16.93,20.81,118.76,118.76,0,0,1-20.83,16.83,100.38,100.38,0,0,1-24.3,11.16,90.58,90.58,0,0,1-52.85,0,100.07,100.07,0,0,1-24.32-11.14,118.82,118.82,0,0,1-20.86-16.82,139.44,139.44,0,0,1-17-20.8,171.89,171.89,0,0,1-22.21-48.76,194.28,194.28,0,0,1-5.38-26.36,198.89,198.89,0,0,1,0-53.69,194.17,194.17,0,0,1,5.39-26.35,171.55,171.55,0,0,1,22.25-48.73,140.27,140.27,0,0,1,17-20.77,118.62,118.62,0,0,1,20.86-16.8,100.71,100.71,0,0,1,24.3-11.09,89.88,89.88,0,0,1,52.77,0,100.29,100.29,0,0,1,24.28,11.12,118.14,118.14,0,0,1,20.83,16.8,140.15,140.15,0,0,1,16.92,20.78,171.28,171.28,0,0,1,22.19,48.71A204,204,0,0,1,1068.84,1985.6Zm-2.36,0a201.18,201.18,0,0,0-6.88-52.59,170.79,170.79,0,0,0-21.45-48.41,139.6,139.6,0,0,0-16.54-20.75,116.37,116.37,0,0,0-20.46-16.84,98.63,98.63,0,0,0-24-11.13,87.7,87.7,0,0,0-52.24,0,98.52,98.52,0,0,0-24,11.16,115.49,115.49,0,0,0-20.44,16.85,138.62,138.62,0,0,0-16.5,20.74,170.54,170.54,0,0,0-21.39,48.4,194.15,194.15,0,0,0-5.15,26,203.75,203.75,0,0,0,0,53,193.73,193.73,0,0,0,5.16,26,170.42,170.42,0,0,0,21.42,48.36,139.24,139.24,0,0,0,16.51,20.73A115.26,115.26,0,0,0,901,2124a98.78,98.78,0,0,0,24,11.11,87.12,87.12,0,0,0,52.16,0,99.12,99.12,0,0,0,24-11.1,115.26,115.26,0,0,0,20.45-16.81,138.21,138.21,0,0,0,16.54-20.72,170.41,170.41,0,0,0,21.48-48.38A201.5,201.5,0,0,0,1066.48,1985.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M951,2144.31a95.45,95.45,0,0,1-27.59-4.1,104.23,104.23,0,0,1-25.31-11.59,122.57,122.57,0,0,1-21.57-17.39,145,145,0,0,1-17.45-21.4,175.23,175.23,0,0,1-22.75-49.92,198.29,198.29,0,0,1-5.49-26.93,203,203,0,0,1,0-54.76,198.32,198.32,0,0,1,5.51-26.91,175.34,175.34,0,0,1,22.78-49.9A145.32,145.32,0,0,1,876.62,1860a122.57,122.57,0,0,1,21.57-17.36,104.29,104.29,0,0,1,25.29-11.55,94.06,94.06,0,0,1,55.1,0,104.48,104.48,0,0,1,25.26,11.55,123.06,123.06,0,0,1,21.54,17.38,144.55,144.55,0,0,1,17.41,21.39,174.59,174.59,0,0,1,22.72,49.87,207.62,207.62,0,0,1,7.37,54.23v0a207.9,207.9,0,0,1-7.32,54.22,175.13,175.13,0,0,1-22.7,49.92,143.19,143.19,0,0,1-17.41,21.41,123,123,0,0,1-21.54,17.41,104,104,0,0,1-25.3,11.6A95.22,95.22,0,0,1,951,2144.31ZM951,1836a86.07,86.07,0,0,0-24.93,3.81,94.87,94.87,0,0,0-23,10.7,111.61,111.61,0,0,0-19.7,16.26,134.37,134.37,0,0,0-16,20.14,166.23,166.23,0,0,0-20.88,47.24,193.4,193.4,0,0,0-5,25.5,206.61,206.61,0,0,0-1.69,26,204.46,204.46,0,0,0,1.71,26,191,191,0,0,0,5,25.49,166.08,166.08,0,0,0,20.9,47.21,134,134,0,0,0,16,20.11,111.7,111.7,0,0,0,19.69,16.24,95,95,0,0,0,23,10.65,83.17,83.17,0,0,0,49.8,0,95.27,95.27,0,0,0,23-10.65,111.21,111.21,0,0,0,19.72-16.22,135.46,135.46,0,0,0,16.06-20.11,166.5,166.5,0,0,0,21-47.23,199.73,199.73,0,0,0,0-103,166.6,166.6,0,0,0-20.93-47.26,134.88,134.88,0,0,0-16.06-20.13A111.87,111.87,0,0,0,999,1850.44a94.68,94.68,0,0,0-23-10.68A86.54,86.54,0,0,0,951,1836Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M813.56,1924.4l35.38-.29,35.38-.16,70.75-.13,70.76.14,35.38.18,35.38.31a.1.1,0,0,1,.1.1s0,.11-.1.11l-35.38.31-35.38.18-70.76.14-70.75-.13-35.38-.16-35.38-.29a.26.26,0,0,1-.16-.07C813.4,1924.47,813.47,1924.4,813.56,1924.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "955.08 1929.35 848.92 1929.06 811.84 1928.75 809.37 1926.27 809.36 1924.46 809.46 1920.5 813.52 1920.34 884.29 1919.89 955.07 1919.76 1061.23 1920.08 1100.63 1920.43 1100.73 1928.61 1096.59 1928.71 1025.85 1929.2 955.08 1929.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M854.6,1864.91c8.37-.13,16.75-.19,25.12-.28l25.12-.17c8.37-.07,16.74-.06,25.12-.08l25.11-.05,50.24.15,25.12.17c8.37.11,16.74.17,25.11.31a.27.27,0,0,1,.11,0c0,.12-.05.16-.11.16-8.37.15-16.74.21-25.11.31l-25.12.18-50.24.14-25.11,0c-8.38,0-16.75,0-25.12-.09l-25.12-.16c-8.37-.1-16.75-.15-25.12-.29a.15.15,0,0,1-.15-.15A.16.16,0,0,1,854.6,1864.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M955.09,1869.86l-31.65-.06c-6.21,0-12.42,0-18.64-.07l-33.49-.25c-5.59-.06-11.18-.11-16.77-.2l-4-.06-.15-8.21,4.13-.15c5.41-.09,10.82-.14,16.23-.2l34-.25c5.89-.05,11.8-.06,17.7-.07l32.56-.07,84.53.43c5.34.06,10.68.11,16,.2l4.12.08-.18,8.15-4,.1c-5.52.09-11.11.15-16.7.21l-33.5.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M801.26,1983.88l38.45-.28,38.46-.17,76.9-.13,76.91.15,38.45.18,38.45.31a.1.1,0,0,1,.11.1s0,.1-.11.1l-38.45.31-38.45.18-76.91.15-76.9-.13-38.46-.17-38.45-.28a.17.17,0,0,1-.15-.16A.16.16,0,0,1,801.26,1983.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "955.08 1988.83 839.7 1988.54 797.22 1988.22 797.07 1979.98 801.23 1979.83 878.15 1979.38 955.07 1979.25 1070.45 1979.57 1110.61 1979.89 1113.05 1982.38 1112.89 1988.1 1108.88 1988.2 1031.99 1988.69 955.08 1988.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M813.56,2043.37l35.38-.29,35.38-.16,70.75-.13,70.76.14,35.38.18,35.38.31a.14.14,0,0,1,.1,0c0,.11,0,.16-.1.16l-35.38.31-35.38.18-70.76.14-70.75-.13-35.38-.16-35.38-.29a.16.16,0,0,1-.16-.16A.16.16,0,0,1,813.56,2043.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "955.08 2048.32 848.92 2048.02 811.84 2047.73 809.37 2045.25 809.36 2043.43 809.45 2039.47 813.52 2039.32 884.3 2038.86 955.07 2038.73 1061.23 2039.05 1100.63 2039.4 1100.73 2047.58 1096.59 2047.69 1025.85 2048.17 955.08 2048.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1060.61,2103.56H859.66a.55.55,0,0,1-.54-.55.54.54,0,0,1,.54-.54h200.95a.54.54,0,0,1,.54.54A.55.55,0,0,1,1060.61,2103.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1060.61,2107.61H859.66a4.6,4.6,0,0,1,0-9.2h200.95a4.6,4.6,0,0,1,0,9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1528.25,2141.12h-54c-11.86,0-20.69-9.34-20.69-21.35V2016.19c0-12,8.83-23.47,20.69-23.47h54c11.69,0,16.39,11.25,16.39,23.47v103.58C1544.64,2132,1539.94,2141.12,1528.25,2141.12Zm-3.84-21v0Zm-50.12-103.82s2.9-.4,2.9-.14v103.58c0,.3-1.35.4-1.35.4l50.93,0c0-.1-2.36-.23-2.36-.38V2016.19a23.71,23.71,0,0,1,3.26.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1628.59,2141.12H1578c-11.49,0-26.56-9.34-26.56-21.35V1957.33c0-12,15.07-18.57,26.56-18.57h50.64c11.3,0,17.23,5.94,17.23,18.57v162.44C1645.82,2132.4,1639.89,2141.12,1628.59,2141.12Zm-50-20.24h48.1a17.15,17.15,0,0,0,2.29-1.11V1957.33c0-.14-2.28-5.08-2.28-5.08h-48.11s-.2,4.92-.2,5.08v162.44A7.26,7.26,0,0,0,1578.57,2120.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1753.75,2122.7a21.8,21.8,0,0,1-21.8,21.79h-57.59a21.79,21.79,0,0,1-21.79-21.79V1906.59a21.79,21.79,0,0,1,21.79-21.8H1732a21.8,21.8,0,0,1,21.8,21.8ZM1736.88,1902a.38.38,0,0,0-.38-.38h-56.57a.38.38,0,0,0-.38.38v215.08a.39.39,0,0,0,.38.39h56.57a.39.39,0,0,0,.38-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1865,2119.32a21.79,21.79,0,0,1-21.79,21.8h-57.6a21.8,21.8,0,0,1-21.79-21.8v-260a21.79,21.79,0,0,1,21.79-21.79h57.6a21.78,21.78,0,0,1,21.79,21.79Zm-23.61-267.87a.38.38,0,0,0-.38-.38h-56.56a.38.38,0,0,0-.39.38v258.92a.38.38,0,0,0,.39.39h56.56a.38.38,0,0,0,.38-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M543.73,2786.93c-31.41,2.2-85.93,5.79-128.91,7.33-25.83.93-40.71-1.13-49.27-3.92,0,.78,0,1.53.08,2.22.2,3.67,3.87,6.62,8.44,6.82,81.21,3.69,145.8,1.28,168.79.14,4.76-.23,7.59-4.44,5.16-7.73A43.19,43.19,0,0,0,543.73,2786.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M414.82,2794.26c43-1.54,97.5-5.13,128.91-7.33-30.88-30.82-128.91-51.6-128.91-51.6H387.14c-19,22.33-21.8,43.59-21.59,55C374.11,2793.13,389,2795.19,414.82,2794.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M382.48,2698.57l2.59,41.7c.28,4.52,4.43,8.31,10,9a55.82,55.82,0,0,0,20.8-1.4c4.83-1.31,8.42-4.62,9.31-8.66l9-40.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M22.88,2804.82c-13.62-1.77-19.78-8.37-22.37-15.44,0,.07,0,.13,0,.19-2,7.45,2.64,15.17,11.93,18.84,11.23,4.44,23.5,5.2,33,4.83,10.23-.39,19.61-4.34,24.77-10.66l.08-.1C60,2807.22,45.6,2807.78,22.88,2804.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M87.11,2695.07H64.28c-34.78-.66-56.62,67.8-63.77,94.31,2.59,7.07,8.75,13.67,22.37,15.44,22.72,3,37.12,2.4,47.39-2.34,18.79-23.07,28.1-56.87,32.58-76.6C107.94,2703.45,87.11,2695.07,87.11,2695.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M67.21,2650.66l-12.68,47.06c-1.55,5.77,1.41,11.74,7.12,14.48,7.09,3.4,17.08,7,26.26,5.93a11.27,11.27,0,0,0,9.32-7.11l18.62-49.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M52.09,2665.23c15.77,14,67.08,15.84,67.08,15.84C304,2237.51,379.58,2174.49,379.58,2174.49c-26.69,167.42-4.31,538.07-4.31,538.07,30.5,13.46,69.82,0,69.82,0A2857.07,2857.07,0,0,1,539.46,2011c-124.91-2.81-191.33-45.55-213-62.7C222.32,2116.15,52.09,2665.23,52.09,2665.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M358.16,1438.19c-23.64,117.93-15.17,329-9.6,425.28,1.56,27.06-17.33,64.57-32.6,90.16a8,8,0,0,0,3.24,11.29c25.57,13.14,112.17,53.86,212.54,58.93a14.32,14.32,0,0,0,14.4-10.7c74.45-278,160.93-455.63,160.93-455.63C611.59,1405.06,358.16,1438.19,358.16,1438.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M392.19,2164a5.91,5.91,0,0,1-5.06-9c1-1.64,24.91-40.28,73.28-63.62a5.92,5.92,0,1,1,5.15,10.66c-45.1,21.76-68.09,58.75-68.32,59.11A5.9,5.9,0,0,1,392.19,2164Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M209.86,1776.64c7.6,54.94,30,114.87,74.92,178.52l17.06-13.91s-19.69-79.92-8.5-170.61C265.66,1765.24,233,1770.8,209.86,1776.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M384.57,1583.7l-26.41-145.51s-176.44,134.86-148.3,338.45c23.1-5.84,55.8-11.4,83.48-6C301.41,1705.3,325.5,1634.38,384.57,1583.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M707.07,1557.52,639,1704.2c11,88.55,58.58,126.84,109.87,141.52a311.16,311.16,0,0,1,22.88-95.51C706.17,1682.54,707.07,1557.52,707.07,1557.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M771.71,1750.21a311.16,311.16,0,0,0-22.88,95.51c136.85,53.1,173-49.87,173-49.87l-25.29-4.47C839.48,1797.4,799.59,1779,771.71,1750.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M644.32,1376.44l-32.88,120.87A23.51,23.51,0,0,1,580,1513c-14.1-5.63-32-13.33-47.39-21.64a31.69,31.69,0,0,1-11.17-45.54l68.36-101.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M984.6,1715,142.1,2021.6a64.52,64.52,0,0,0-36.66,87.33l2.56,5.62a60,60,0,0,0,79.76,29.6l818.06-378.44Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-53",
    cx: 1371.85,
    cy: 1530.51,
    rx: 415.9,
    ry: 408.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1371.85,1076.08c-255.59,0-462.78,203.46-462.78,454.43S1116.26,1985,1371.85,1985s462.78-203.46,462.78-454.44S1627.44,1076.08,1371.85,1076.08Zm0,842.11c-218,0-394.8-173.57-394.8-387.68s176.76-387.68,394.8-387.68,394.8,173.57,394.8,387.68S1589.89,1918.19,1371.85,1918.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M944.25,1586.48a2.79,2.79,0,0,1-2.75-2.43c-1.37-10.77-2.34-21.72-2.88-32.56a2.79,2.79,0,0,1,2.64-2.91,2.71,2.71,0,0,1,2.91,2.64c.53,10.69,1.48,21.5,2.84,32.13a2.79,2.79,0,0,1-2.4,3.11Zm3.18-127.07a2.72,2.72,0,0,1-.49-.05,2.76,2.76,0,0,1-2.24-3.22,417.4,417.4,0,0,1,24.94-85.38h0c66.66-161.71,224.53-266.21,402.2-266.21a438.1,438.1,0,0,1,232.91,66.57,2.77,2.77,0,1,1-3,4.7,432.58,432.58,0,0,0-230-65.71c-175.41,0-331.27,103.15-397.07,262.78h0a412.53,412.53,0,0,0-24.62,84.24A2.78,2.78,0,0,1,947.43,1459.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M716.25,1284.61c.3,2.08-27.42,137.93-27.42,137.93l-77.24-17.48,7.15-132.66S711.24,1249.86,716.25,1284.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M636.11,1302l-9.23,69.54a9.48,9.48,0,0,0,0,2.66c.78,5.46,4.83,24,23.57,18.71,17-4.82,32.58-9,43.35-5.67a9.79,9.79,0,0,1,6.73,11.33c-2.52,12.34-8.71,40-17.77,63.3a9.77,9.77,0,0,1-11.87,5.78c-14.65-4.27-45.29-14.14-68.08-27.86a9.76,9.76,0,0,1-4.77-8.81c.74-17.56,2.79-70.93,1.06-85.89-1.62-14-18.85-22.45-26.34-25.47a9.61,9.61,0,0,1-5.36-5.38c-3.47-8.68-8.25-28.79,17.09-37a9.81,9.81,0,0,0,6.21-12.69c-3.75-10.45-5.33-26.39,14.27-35.17,19.92-8.93,34.8,1.69,42.83,10.32a9.82,9.82,0,0,0,12.5,1.48c2.29-1.45,5.25-1.93,8.82.29a9.65,9.65,0,0,0,13.67-4.14c4.77-9.79,14.49-20.28,34-16.94,34.61,5.93,38.53,44.28,29.4,66.75s-46.28,13.92-64.93,2.59c-14.17-8.62-32.55.41-40.55,5.24A9.72,9.72,0,0,0,636.11,1302Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M596,1370.41s14.23-39.85-.39-49.6-36.26-4.69-31.5,24.17C570,1380.88,596,1370.41,596,1370.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M294.81,1938.82l79.64-6.49,34.5,31.8s-8.16,11.28-33.68,4.8-60.46-8.08-60.46-8.08-35.22,15.88-35.64-13.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M911.74,1814.69c6.89,5.38,30.49-5.86,44.93-13.62a16.64,16.64,0,0,0,8-19.64c-3.48-11-9.27-25.1-16.4-26.88C936.46,1751.59,883.35,1792.51,911.74,1814.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M158.73,2132a2.85,2.85,0,0,1-.91-.15c-32.74-11.32-40.35-30.63-41-44.84-.9-20.77,12.16-40,32.48-48l101.16-39.44a2.77,2.77,0,1,1,2,5.17l-101.16,39.45c-18.1,7.06-29.74,24.16-28.94,42.55.79,18.16,13.32,31.56,37.23,39.83a2.78,2.78,0,0,1-.9,5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M282.67,1992.84a2.77,2.77,0,0,1-1-5.36l13.11-5.12a2.78,2.78,0,0,1,2,5.18l-13.12,5.11A2.73,2.73,0,0,1,282.67,1992.84Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness2);
export default __webpack_public_path__ + "static/media/business_2.6ff1c4860fb5bcf7afc1a58482f4b608.svg";
export { ForwardRef as ReactComponent };